import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form as FormikForm } from 'formik';

import { Grid } from '@material-ui/core';

import {
  ClientFollowMappingFragment,
  useUpdateClientFollowMappingMutation,
  UpdateClientFollowMappingInput,
} from 'api';
import { useNotify } from 'hooks';
import { OnboardingSchema } from 'features/admin/validations';
import { useUpdateClientFollowMapping } from 'features/admin/updaters';
import CustomMapping from './Custom/Mapping';

interface IProps {
  mappings: ClientFollowMappingFragment[];
}

const Custom: FC<IProps> = ({ mappings }) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const mutationOptions = useUpdateClientFollowMapping();
  const { mutate } = useUpdateClientFollowMappingMutation({
    onSuccess: editNotify,
    ...mutationOptions,
  });

  function getRequiredValues(values: UpdateClientFollowMappingInput | ClientFollowMappingFragment) {
    const { id, title, mapping_status, all_users } = values;
    return { id, title, mapping_status, all_users };
  }

  function handleEdit(values: UpdateClientFollowMappingInput) {
    return mutate({ data: getRequiredValues(values) });
  }

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  function renderCustom(mapping: ClientFollowMappingFragment) {
    return (
      <FormikForm>
        <CustomMapping mapping={mapping} />
      </FormikForm>
    );
  }

  return (
    <Grid container direction="column" spacing={4} wrap="nowrap">
      {mappings.map(mapping => (
        <Grid key={mapping.id} item>
          <Formik
            initialValues={getRequiredValues(mapping)}
            onSubmit={handleEdit}
            validationSchema={OnboardingSchema}
          >
            {renderCustom(mapping)}
          </Formik>
        </Grid>
      ))}
    </Grid>
  );
};

export default Custom;
